import { render, staticRenderFns } from "./labo.vue?vue&type=template&id=31d9a7b4&"
import script from "./labo.vue?vue&type=script&lang=js&"
export * from "./labo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports